import api from '../utils/request'

export default {
  // 列表 + 组合查询：department / device_name /
  // verify_date_start / verify_date_end / expire_date_start / expire_date_end
  list(params) {
    return api.get('/report-reminder/safety-valve/', { params })
  },
  // 列表顶部汇总：已过期 / 30 天内到期 / 合计（跟随当前筛选条件，不分页）
  stats(params) {
    return api.get('/report-reminder/safety-valve/stats/', { params })
  },
  // 导出：按当前查询条件返回全部匹配记录（不分页）；传空参数即导出全部
  export(params) {
    return api.get('/report-reminder/safety-valve/export/', { params })
  },
  // 新增（含单个 PDF，FormData）
  create(data) {
    return api.post('/report-reminder/safety-valve/', data)
  },
  // 编辑（含可选 PDF 替换，FormData）
  update(id, data) {
    return api.put(`/report-reminder/safety-valve/${id}/`, data)
  },
  // 删除：数据库删除记录，并把报告 PDF 移入「报告提醒/安全阀/删除/」文件夹
  delete(id) {
    return api.delete(`/report-reminder/safety-valve/${id}/`)
  },
  // 归档（重新校验）：移动旧报告到归档目录并按规范命名，更新校验日期，存入新报告
  archive(id, data) {
    return api.post(`/report-reminder/safety-valve/${id}/archive/`, data)
  },
  // 试验接口：上传 PDF 自动提取安全阀字段
  // 扫描件需 PDF 渲染 + RapidOCR，多页报告常超过 30s，单独放宽超时到 3 分钟
  extractPdf(data) {
    return api.post('/report-reminder/safety-valve/extract-pdf/', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 180000,
    })
  },
  // 试验接口：用当前已识别并校准的报告生成坐标模板（存为模板识别）
  // 同样走 OCR，放宽超时到 3 分钟
  saveTemplate(data) {
    return api.post('/report-reminder/safety-valve/save-template/', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 180000,
    })
  },
  // 查看归档记录：列出本条记录在硬盘「归档」文件夹中的历史报告文件
  archiveFiles(id) {
    return api.get(`/report-reminder/safety-valve/${id}/archive-files/`)
  },
  // 获取所选记录可导出报告的所有年份（含当前报告 + 已归档报告），用于导出弹窗动态渲染年份多选框
  availableYears(ids) {
    return api.get('/report-reminder/safety-valve/available-years/', {
      params: { ids: ids.join(',') },
    })
  },
  // 导出报告 PDF：按选中的记录 ID + 年份筛选，后端打包成 ZIP 下载
  exportFiles(data) {
    return api.post('/report-reminder/safety-valve/export-files/', data, {
      responseType: 'blob',
      timeout: 120000,
    })
  },
}
